import './FilterPanel.scss';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { FilterToggle } from '@components/Component/Field/Select/FilterToggle/FilterToggle.js';
import { Panel } from '@components/Component/Container/Panel/Panel.js';
import { isMobile } from '@components/Utility/index.js';
export class FilterPanel extends Panel {
    get includeRunButton() { return this._includeRunButton; }
    set includeRunButton(value) {
        this._propertySet('includeRunButton', value);
        this.refreshButton('run');
    }
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'FilterPanel';
        this._includeRunButton = true;
        this.designerDragType = 'none'; // dont allow dragging the entire panel
        this.width = '300';
        this.captionKey = 'system_filters';
    }
    handleEnterKey() {
        if (this.includeRunButton) {
            this.buttonClick('run');
            this.close();
            return true;
        }
        else if (this.primaryGridComponentGet()) {
            this.primaryGridComponentGet().refreshData();
        }
        return false;
    }
    initializeProperties() {
        super.initializeProperties();
        this.compositeContainer = true;
    }
    initializeComponents() {
        super.initializeComponents();
        const filterToggle = new FilterToggle(this.id + '_filtertoggle');
        // this.filterToggle.buttonHiddenSet('save', true);
        // this.filterToggle.buttonHiddenSet('refresh', true);
        filterToggle.showLabel = false;
        filterToggle.ignoreChildTemplate = true;
        this.componentAdd(filterToggle);
    }
    initializeButtons() {
        super.initializeButtons();
        this.buttonAdd({
            icon: 'add',
            containerId: 'control',
            includeProperty: 'formDesignerMode',
            id: 'add',
            index: -999,
            classList: ['form-designer-add'],
            onClick: () => {
                // Q360FormDesigner handles the click based on that class name form-designer-add
            }
        });
        this.buttonAdd({
            icon: '',
            captionKey: 'system_applyfilter',
            id: 'run',
            includeProperty: 'includeRunButton',
            defaultIncludePropertyValue: true,
            eventConfigName: 'run',
            classList: ['primary', 'button-style'],
            onClick: () => {
                this.trigger('run', {
                    defaultEventHandler: () => {
                        const filterSet = this.parentComponentGet();
                        filterSet.childContainerGet().querySelectorAll('.s360Grid, .s360GanttChart, .s360Scheduler, .s360Chart, .s360Map').forEach((element) => {
                            const globalId = element.getAttribute('data-global-id');
                            if (globalId) {
                                DIContainer.getInstance('ComponentRegistry').getComponent(globalId)?.refreshData({ ignoreVisibility: true });
                            }
                        });
                        if (isMobile()) {
                            filterSet.togglePanel(this.id);
                        }
                    }
                });
            }
        });
        // ignoreChildTemplate
    }
    draw() {
        // this.contentContainer = this.rootElement;
        this.rootElement.classList.add('s360Panel');
        super.draw();
        const ftContainer = this.rootElement.querySelector('.filter-toggle-container');
        this.componentGet(`${this.id}_filtertoggle`).propertyGet$('staticParameters')
            .subscribe((params) => {
            ftContainer.classList.toggle('d-none', !params.module);
        });
    }
    formDesignerSetup() {
    }
    modalContentTemplate() {
        return `<div class="filter-toggle-container">
	<div data-componentid="${this.id}_filtertoggle"></div>
</div><div class="modal-content">
	<div class="child-container"></div>
</div>
<div class="panel-footer">
	<div class="button-container"></div>
</div>`;
    }
    formDesignerPropertiesGet(properties) {
        properties = super.formDesignerPropertiesGet(properties);
        properties.side = ({
            id: 'side',
            value: this.side,
            componentType: 'Select',
            componentProperties: {
                staticOptionData: [
                    { value: 'left', display: 'Left' },
                    { value: 'right', display: 'Right' }
                ]
            },
            captionKey: 'formbuilder_filterpanel_side',
            propertyGroup: 'layout',
            saveFlag: () => this.side === 'left'
        });
        properties.icon = ({
            id: 'icon',
            value: this.icon,
            componentType: 'Input',
            componentProperties: {},
            captionKey: 'formbuilder_icon',
            propertyGroup: 'caption',
            saveFlag: () => !!this.icon
        });
        properties.width = ({
            id: 'width',
            value: this._width,
            componentType: 'Input',
            componentProperties: {},
            captionKey: 'formbuilder_filterpanel_panelwidth',
            propertyGroup: 'caption',
            saveFlag: () => this._width != '300' && this._width != '300px'
        });
        return properties;
    }
}
FilterPanel.VERSION = '$Revision: 111642 $';
